import { tApi } from 'tplus-api';
import { stores } from 'mutants-microfx';
import '../commom/Challenger';

import { platform } from 'mutants-util';

import { toJS } from 'mobx';

export default class ProductApi {

    //获取存货明细信息
    static async getProductDetail(params) {
        $T.debugger();
        let idInventory = params.IdInventory;
        let isReturn = params.IsReturn;
        let dto = params.dto;
        let IdMember = dto.Idmember;
        let Idstore = dto.Idstore;
        let BarCode = params.BarCode || '';
        let voucherMode = params.voucherMode || '';
        let serialNumberId = params.SerialNumberId || '';
        let paramsJson = {
            IdInventory: idInventory,
            IdMember: IdMember,
            Idstore: Idstore,
            BarCode: BarCode,
            IsReturn: isReturn,
            IsSelfCash: platform.isVerticalTouch,
            voucherMode: voucherMode,
            serialNumberId: serialNumberId
        }
        return await tApi({
            "paramsJson": JSON.stringify(paramsJson)
        }, 'chanjet.AA.DR.newRetailBaseInfo.GetInventoryData', false, false);
    }

    /**
     * 校验可用量
     * @param {*} dto
     */
    static async checkInventoryAvailableQuantity(dto) {
        if (!dto) {
            return;
        }
        let cutDto = toJS(dto.cut());
        return await tApi({
            "dto": cutDto
        }, 'chanjet.AA.DR.newRetailBaseInfo.InventoryAvailableQuantityCheck', false, false);
    }

    /**
    * 检验单据日期是否合法
    * @param {voucherDate} voucherDate
    */
    static async checkVoucherDate(voucherDate) {
        return await tApi({ voucherDate: voucherDate }, 'chanjet.RE.INewRetail.CheckVoucherDate', false, false);
    }

}

